import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { htmlStyleToReactStyle } from '../utils/index.js';
var _excluded = ["text"];
var Leaf = function Leaf(_ref) {
  var attributes = _ref.attributes,
    children = _ref.children,
    leaf = _ref.leaf;
  leaf.text;
  var rest = _objectWithoutProperties(leaf, _excluded);
  var customLeaf = leaf;
  var cls = '';
  var style = {};
  Object.keys(rest).forEach(function (key) {
    if (key === 'class') cls = rest[key];
    if (key === 'style' && typeof rest[key] === 'string') {
      style = htmlStyleToReactStyle(rest[key]);
    }
  });
  if (customLeaf.bold) {
    children = /*#__PURE__*/React.createElement("strong", null, children);
  }
  if (customLeaf.italic) {
    children = /*#__PURE__*/React.createElement("i", null, children);
  }
  return /*#__PURE__*/React.createElement("span", _extends({}, attributes, {
    className: cls,
    style: style
  }), children);
};
Leaf.displayName = "Leaf";
export { Leaf };